import React from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const InputAutocomplete = (props) => {
  return (
    <Autocomplete
      autoSelect
      onChange={(e) => props.Change_Data(props.data_key, e.target.innerHTML)}
      inputValue={props.value}
      style={{ float: "right", width: "100%" }}
      options={props.options}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => props.Change_Data(props.data_key, e.target.value)}
          multiline={typeof props.multiline ? true : false}
        />
      )}
    />
  );
};

export default InputAutocomplete;
